// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Presse_Page from "../../presse/Presse_Page.bs.js";
import * as Atom_Divider from "../atom/Atom_Divider.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Layout_Guide_Column_Presse from "../layout/presse/guide/Layout_Guide_Column_Presse.bs.js";
import * as Layout_Guide_Slider_Presse from "../layout/presse/guide/Layout_Guide_Slider_Presse.bs.js";

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("S"));

function Page_Guide_Presse(Props) {
  var initialDate = Props.initialDate;
  var selectedDate = Props.selectedDate;
  var getSelectedDate = Props.getSelectedDate;
  var page = Props.page;
  var weekPrefixLabel = Props.weekPrefixLabel;
  var labelAllDayFilter = Props.labelAllDayFilter;
  var labelAfternoonFilter = Props.labelAfternoonFilter;
  var downloadItems = page.weekDownload;
  var downloadAllLabel = page.labels.download_all;
  var broadcasts = Belt_Array.map(page.programming, Presse_Page.toDsBroadcast);
  return React.createElement(Atom_Column.make, {
              blockSpace: blockSpace,
              children: null
            }, React.createElement(Layout_Guide_Slider_Presse.make, {
                  initialDate: initialDate,
                  getSelectedDate: getSelectedDate,
                  selectedDate: selectedDate,
                  downloadItems: downloadItems,
                  downloadAllLabel: downloadAllLabel,
                  weekPrefixLabel: weekPrefixLabel
                }), React.createElement(Atom_Divider.make, {
                  style: Atom_Divider.presseGuide
                }), React.createElement(Layout_Guide_Column_Presse.make, {
                  broadcasts: broadcasts,
                  initialDate: initialDate,
                  labelAllDayFilter: labelAllDayFilter,
                  labelAfternoonFilter: labelAfternoonFilter
                }));
}

var make = Page_Guide_Presse;

export {
  blockSpace ,
  make ,
}
/* blockSpace Not a pure module */
